import { Spin } from '@bedrock/components';

export default Spin;
